module.exports = __webpack_public_path__ + "img/pin-dark.26971866.svg";